import _ from "lodash";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";

export const cloneItem = (
    itemsInOrder,
    orderItemsPanelSelection,
    SelectedItemName,
    forceNew = false,
    itemIdentifier = null
) => {
    let itemInOrder;
    if (itemsInOrder && itemsInOrder.items && itemsInOrder.items.length > 0)
        itemInOrder = _.find(itemsInOrder.items, {
            item_code: SelectedItemName,
        });

    let finalQuantity = 0;
    if (!itemInOrder) {
        // We will create a new copy object and add the quantity to it.
        // Original object
        if (orderItemsPanelSelection) {
            itemInOrder = { ...orderItemsPanelSelection };
        }
        finalQuantity = 1;
    } else {
        finalQuantity = itemInOrder.qty + 1;
        // itemInOrder.identifier = itemInOrder.identifier;
    }

    itemInOrder = _.cloneDeep(itemInOrder);

    // We will remove this but when we update the model, basically the keyword is qty not pos_qty. !.
    itemInOrder.qty = finalQuantity;
    const date = new Date();
    const formattedDate = moment(date).format("YYYY-MM-DD HH:mm:ss.SSSSSSSSS");
    itemInOrder.ordered_time = formattedDate;
    if (forceNew) {
        itemInOrder.identifier = "entry_" + uuidv4();
    } else {
        if (itemIdentifier && itemIdentifier.length > 0) {
            itemInOrder.identifier = itemIdentifier;
        } else {
            // We should not reach here at all, but this is hiding a bug ..!
            itemInOrder.identifier = "entry_" + uuidv4();
        }
    }

    return itemInOrder;
};

export const cloneAddOn = (systemAdOnItem, qty, parentIdentifier) => {
    let clonedItem = _.cloneDeep(systemAdOnItem);

    // We will remove this but when we update the model, basically the keyword is qty not pos_qty. !.
    clonedItem.qty = qty;
    const date = new Date();
    const formattedDate = moment(date).format("YYYY-MM-DD HH:mm:ss.SSSSSSSSS");

    clonedItem.price_list_rate = systemAdOnItem.standard_rate;
    clonedItem.rate = systemAdOnItem.standard_rate;
    clonedItem.parent_item = parentIdentifier;
    clonedItem.standard_rate = systemAdOnItem.standard_rate;
    clonedItem.ordered_time = formattedDate;
    clonedItem.discount_percentage = 0;
    clonedItem.item_tax_template = "";
    clonedItem.item_tax_rate = "{}";
    clonedItem.status = "Completed";
    clonedItem.has_serial_no = 0;
    clonedItem.serial_no = "";
    clonedItem.has_batch_no = 0;
    clonedItem.batch_no = "";
    clonedItem.notes = "";
    clonedItem.identifier = "entry_addon_" + uuidv4();

    return clonedItem;
};

export const getOrderShortName = (orderName) => {
    if (orderName) {
        return orderName.split("-").slice(-1);
    } else {
        return "";
    }
};

export const parseCustomerAddress = (customer) => {
    let address = customer?.territory;

    if (
        customer &&
        customer.primary_address &&
        customer.primary_address.split("<br>")[0]
    ) {
        address += " - " + customer.primary_address.split("<br>")[0];
    }

    if (
        customer &&
        customer.primary_address &&
        customer.primary_address.split("<br>")[1]
    ) {
        address += " - " + customer.primary_address.split("<br>")[1];
    }

    return address;
};

export const parseAddress = (address) => {
    let parsedAddress = "";
    if (address) {
        if (address.territory) {
            parsedAddress += address.territory;
        }

        if (address.address_line1) {
            parsedAddress += " - " + address.address_line1;
        }

        if (address.address_line2) {
            parsedAddress += " - " + address.address_line2;
        }

        return parsedAddress;
    }
    return "";
};

export const randomId = (length) => {
    let result = "";
    const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
        counter += 1;
    }
    return result;
};

export const isJsonString = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};
